let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kUGmc")).then(() => parcelRequire('7T3TJ'));